// src/components/Testimonials.js
import React, { useState } from 'react';
import './Testimonials.css';

function Testimonials() {
  // Example testimonials data
  const testimonials = [
    {
      name: 'Gautam Agarwal',
      position: 'CEO of Tech For Sapien Inc.',
      image: 'ct.jpg',
      quote:
        '“Partnering with Left Right Solutions has been a game changer for my business. Their expertise in navigating complex visa requirements and comprehensive consultancy services have streamlined processes that once seemed daunting. I appreciate the seamless interface of their platform and the exceptional support from their team—it truly feels like an extension of my own business operations.”',
    },
    {
      name: 'Aditya Patil',
      position: 'Director at Global Ventures',
      image: 'ct.jpg',
      quote:
        '“Working with Left Right Solutions made our international expansion so much smoother. They took care of the paperwork, guided us through every step, and provided a level of service that exceeded all expectations.”',
    },
    {
      name: 'Kishlay Sahay',
      position: 'Founder at Sahay Enterprises',
      image: 'ct.jpg',
      quote:
        '“I never thought visa and attestation processes could be this painless until I discovered Left Right Solutions. Their team is highly professional, responsive, and truly understands the nuances of global business.”',
    },
  ];

  // State to track current testimonial index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handlers for navigation
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Destructure the current testimonial
  const { name, position, image, quote } = testimonials[currentIndex];

  return (
    <section className="testimonials">
      <div className="testimonials-content">
        <h2 className="testimonials-title">Client Testimonials</h2>
        <p className="testimonials-subtitle">
          Hear from peers about their successes with us.
        </p>

        <div className="testimonial-card">
          <div className="testimonial-image">
            <img src={image} alt={name} />
          </div>
          <div className="testimonial-text">
            <blockquote>{quote}</blockquote>
            <p className="testimonial-author">
              {name}, <span>{position}</span>
            </p>
          </div>
        </div>

        <div className="testimonial-controls">
          <button className="arrow-button" onClick={handlePrev}>
            &lt;
          </button>
          <button className="arrow-button" onClick={handleNext}>
            &gt;
          </button>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
